import { logoBase64 } from './logoBase64';

const getFormattedDateSuffix = () => {
    const d = new Date();
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return ` as at ${day}/${month}/${year}`;
};

export const exportToCSV = (dtRef, baseFilename) => {
    if (dtRef && dtRef.current) {
        const filename = `${baseFilename}${getFormattedDateSuffix()}`;
        dtRef.current.exportCSV({ selectionOnly: false, filename: filename.replace(/\//g, '-') });
    }
};

export const exportToPDF = (dtRef, baseFilename, title) => {
    if (!dtRef || !dtRef.current) return;
    
    import('jspdf').then((jsPDF) => {
        import('jspdf-autotable').then(() => {
            const doc = new jsPDF.default();
            
            // Add Doves Logo
            doc.addImage(logoBase64, 'PNG', 14, 10, 40, 20); // x, y, width, height
            
            if (title) {
                doc.setFontSize(16);
                doc.text(`${title}${getFormattedDateSuffix()}`, 14, 40);
            }
            
            let columns = [];
            const dtProps = dtRef.current.props;
            
            if (dtProps && dtProps.children) {
                const childrenArray = Array.isArray(dtProps.children) ? dtProps.children : [dtProps.children];
                childrenArray.forEach(child => {
                    if (child && child.props && child.props.field && child.props.header && child.props.header !== 'Actions' && child.props.header !== 'Action' && child.props.header !== 'View Full Policy') {
                        columns.push({ header: child.props.header, field: child.props.field });
                    } else if (child && Array.isArray(child)) {
                        child.forEach(subchild => {
                            if (subchild && subchild.props && subchild.props.field && subchild.props.header && subchild.props.header !== 'Actions' && subchild.props.header !== 'Action') {
                                columns.push({ header: subchild.props.header, field: subchild.props.field });
                            }
                        });
                    }
                });
            }
            
            const data = dtRef.current.props ? dtRef.current.props.value : [] || [];
            
            if (columns.length === 0 && data.length > 0) {
                // Fallback to extracting keys from first data row
                columns = Object.keys(data[0]).map(key => ({ header: key.toUpperCase(), field: key }));
            }
            
            doc.autoTable({
                head: [columns.map(col => col.header)],
                body: data.map(row => columns.map(col => {
                    let val = row[col.field];
                    if (val === undefined || val === null) return '';
                    if (typeof val === 'object') return JSON.stringify(val);
                    return String(val);
                })),
                startY: title ? 45 : 35,
                theme: 'striped',
                styles: { fontSize: 8 },
                headStyles: { fillColor: [41, 128, 185] },
            });
            
            const filename = `${baseFilename}${getFormattedDateSuffix()}`;
            // Convert slash to hyphen ONLY for the save file name, because saving with '/' is strictly forbidden in OS paths.
            // The browser will otherwise mangle the filename or throw an error.
            doc.save(`${filename.replace(/\//g, '-')}.pdf`);
        });
    });
};
